// 优惠券管理
import http from "@/jslibs/axios/http";

// 优惠券列表
export const list = (data) => http.get(`/v1/cms/Coupon`, data);

// 优惠券添加
export const add = (data) => http.post(`/v1/cms/Coupon`, data);

// 优惠券编辑
export const edit = ({ uuid, ...data }) => http.put(`/v1/cms/Coupon/${uuid}`, data);

// 优惠券详情
export const detail = ({ cuuid, ...data }) => http.get(`/v1/cms/Coupon/${cuuid}`, data);

// 优惠券删除
export const del = ({ cuuid }) => http.delete(`/v1/cms/Coupon/${cuuid}`);

// 领取详情
export const userlist = (data) => http.get(`/v1/cms/Coupon/userlist`, data);

// 使用优惠券
export const consume = ({ uuid, ...data }) => http.put(`/v1/cms/Coupon/consume/${uuid}`, data);

// 优惠券数据c
export const data = ({ cuuid }) => http.get(`/v1/cms/Coupon/data/${cuuid}`);

// 国家列表
export const country = () => http.get(`/v1/cms/Coupon/country`);
